import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=495c007e&scoped=true&lang=pug&"
var script = {}
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=495c007e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495c007e",
  null
  
)

export default component.exports